// extracted by mini-css-extract-plugin
export default {"summary":"summary---i0hnq","titleRow":"titleRow---ln2TM","badge":"badge---GpJOf","hint":"hint---pb1PT","downloadSection":"downloadSection---FZcSK","issueList":"issueList---qrWeH"};